import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Info: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M27 16c0-6.075-4.925-11-11-11S5 9.925 5 16s4.925 11 11 11 11-4.925 11-11Zm-12.392-1.922c1.528-.764 3.249.616 2.835 2.274l-.946 3.78.056-.027a1 1 0 0 1 .894 1.79l-.055.027c-1.528.764-3.249-.616-2.835-2.274l.946-3.78-.056.027a1 1 0 0 1-.894-1.79l.055-.027ZM16.01 10a1 1 0 0 1 1 1v.01a1 1 0 0 1-1 1H16a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h.01ZM29 16c0 7.18-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3s13 5.82 13 13Z"
    />
  </Icon>
);
